// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}", ""]);
// Exports
module.exports = exports;
